<template>
    <div class="bg-white dark:bg-gray-800 shadow rounded-lg">
        <div class="px-4 py-5 sm:p-6">
            <h3
                class="text-lg leading-6 font-medium text-gray-900 dark:text-white mb-4"
            >
                Quick Actions
            </h3>
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                <router-link
                    v-for="action in actions"
                    :key="action.id"
                    :to="action.route"
                    :class="[
                        'flex items-center p-3 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150',
                        action.color
                            ? `border-${action.color}-200 dark:border-${action.color}-700`
                            : '',
                    ]"
                >
                    <div
                        v-if="action.color"
                        :class="[
                            'w-8 h-8 rounded-md flex items-center justify-center mr-3',
                            `bg-${action.color}-100 dark:bg-${action.color}-900`,
                        ]"
                    >
                        <component
                            :is="getIconComponent(action.icon)"
                            :class="[
                                'w-4 h-4',
                                `text-${action.color}-600 dark:text-${action.color}-300`,
                            ]"
                            aria-hidden="true"
                        />
                    </div>
                    <component
                        v-else
                        :is="getIconComponent(action.icon)"
                        class="w-5 h-5 text-gray-400 mr-3"
                        aria-hidden="true"
                    />
                    <span
                        class="text-sm font-medium text-gray-900 dark:text-white"
                    >
                        {{ action.label }}
                    </span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { QuickAction } from "@/types/dashboard";
import {
    Users,
    GraduationCap,
    BookOpen,
    ClipboardList,
    CircleHelp,
    Calendar,
    BarChart3,
    CheckCircle,
    Clock,
    TriangleAlert,
    User,
    FileText,
    ShieldCheck,
    Settings,
    Home,
    Plus,
    Pencil,
    Eye,
} from "@lucide/vue";

interface Props {
    actions: QuickAction[];
}

defineProps<Props>();

const getIconComponent = (iconName: string) => {
    const icons: { [key: string]: any } = {
        UserGroupIcon: Users,
        UsersIcon: Users,
        Users,
        AcademicCapIcon: GraduationCap,
        GraduationCap,
        BookOpenIcon: BookOpen,
        BookOpen,
        ClipboardDocumentListIcon: ClipboardList,
        ClipboardList,
        QuestionMarkCircleIcon: CircleHelp,
        CircleHelp,
        CalendarIcon: Calendar,
        Calendar,
        ChartBarIcon: BarChart3,
        BarChart3,
        CheckCircleIcon: CheckCircle,
        CheckCircle,
        ClockIcon: Clock,
        Clock,
        ExclamationTriangleIcon: TriangleAlert,
        TriangleAlert,
        UserIcon: User,
        User,
        DocumentTextIcon: FileText,
        FileText,
        ShieldCheckIcon: ShieldCheck,
        ShieldCheck,
        Cog6ToothIcon: Settings,
        Settings,
        HomeIcon: Home,
        Home,
        PlusIcon: Plus,
        Plus,
        PencilIcon: Pencil,
        Pencil,
        EyeIcon: Eye,
        Eye,
    };

    return icons[iconName] || Home;
};
</script>
